<template>
  <div class="create-page pa-6">
    <p-progress-linear v-if="page.isLoading " :indeterminate="true" color="base" height="10">
    </p-progress-linear>
    <p-container v-if="!page.isLoading && page.user && page.user.id">
      <h2 class="mb-4">
        <p-button tertiary @click="$router.back()">
          <p-icon>keyboard_backspace</p-icon>
        </p-button>
        {{ $t('page.dashboard.companies.feedbacks.createFeedback.title') }}
      </h2>
      <p-card>
        <p-row>
          <p-col>
            <p-form v-if="page.createFeedbackModel" :model="page.createFeedbackModel">
              <p-alert :value="!page.isFeedbackEnabled" type="info">
                {{ $t('page.dashboard.companies.feedbacks.alert.feedbackDisabled') }}
              </p-alert>
              <p-row>
                <h4 class="title">
                  {{ $t('page.dashboard.companies.feedbacks.eventRating.title') }}
                </h4>
              </p-row>
              <p-row>
                <p-col xs12 md6 lg2>
                  <p-radio-field v-model="page.createFeedbackModel.eventRating" :disabled="!page.isFeedbackEnabled" :true-value="1" name="eventRating" :label="$tEnum('page.dashboard.companies.feedbacks.enum.eventRating', 1)"></p-radio-field>
                </p-col>
                <p-col xs12 md6 lg2>
                  <p-radio-field v-model="page.createFeedbackModel.eventRating" :disabled="!page.isFeedbackEnabled" :true-value="2" name="eventRating" :label="$tEnum('page.dashboard.companies.feedbacks.enum.eventRating', 2)"></p-radio-field>
                </p-col>
                <p-col xs12 md6 lg2>
                  <p-radio-field v-model="page.createFeedbackModel.eventRating" :disabled="!page.isFeedbackEnabled" :true-value="3" name="eventRating" :label="$tEnum('page.dashboard.companies.feedbacks.enum.eventRating', 3)"></p-radio-field>
                </p-col>
              </p-row>
              <p-row>
                <h4 class="title">
                  {{ $t('page.dashboard.companies.feedbacks.reparticipationRating.title') }}
                </h4>
              </p-row>
              <p-row>
                <p-col xs12 md6 lg2>
                  <p-radio-field v-model="page.createFeedbackModel.reparticipationRating" :disabled="!page.isFeedbackEnabled" :true-value="1" name="reparticipationRating" :label="$tEnum('page.dashboard.companies.feedbacks.enum.reparticipationRating', 1)"></p-radio-field>
                </p-col>
                <p-col xs12 md6 lg2>
                  <p-radio-field v-model="page.createFeedbackModel.reparticipationRating" :disabled="!page.isFeedbackEnabled" :true-value="2" name="reparticipationRating" :label="$tEnum('page.dashboard.companies.feedbacks.enum.reparticipationRating', 2)"></p-radio-field>
                </p-col>
                <p-col xs12 md6 lg2>
                  <p-radio-field v-model="page.createFeedbackModel.reparticipationRating" :disabled="!page.isFeedbackEnabled" :true-value="3" name="reparticipationRating" :label="$tEnum('page.dashboard.companies.feedbacks.enum.reparticipationRating', 3)"></p-radio-field>
                </p-col>
              </p-row>
              <p-row>
                <h4 class="title">
                  {{ $t('page.dashboard.companies.feedbacks.visitorsCount.title') }}
                </h4>
              </p-row>
              <p-row>
                <p-col xs12 md6 lg3>
                  <p-number-field v-model="page.createFeedbackModel.youthVisitorsCount" :disabled="!page.isFeedbackEnabled" label="Jugendliche" required>
                  </p-number-field>
                </p-col>
              </p-row>
              <p-row>
                <p-col xs12 md6 lg3>
                  <p-number-field v-model="page.createFeedbackModel.adultVisitorsCount" :disabled="!page.isFeedbackEnabled" label="Erwachsene">
                  </p-number-field>
                </p-col>
              </p-row>
              <p-row>
                <h4 class="title">
                  {{ $t('page.dashboard.companies.feedbacks.remark.title') }}
                </h4>
              </p-row>
              <p-row>
                <p-col xs12 md6 lg3>
                  <p-textarea v-model="page.createFeedbackModel.remark" :disabled="!page.isFeedbackEnabled" :label="$t('page.dashboard.companies.feedbacks.remark.label')">
                  </p-textarea>
                </p-col>
              </p-row>
              <p-row>
                <p-button @click="$router.back()">
                  {{ $t('core.app.cancel') }}
                </p-button>
                <p-button :loading="page.isLoadingButton" :disabled="!page.isFeedbackEnabled" @click="page.saveNewFeedback()">
                  {{ $t('core.app.save') }}
                </p-button>
              </p-row>
            </p-form>
            <p-request-alert v-model="page.error"></p-request-alert>
          </p-col>
        </p-row>
      </p-card>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import FeedbacksPage from './create.vue.model';

  export default Vue.extend({
    name: 'Feedbacks',
    data: () => ({
      page: new FeedbacksPage(),
    }),
    async beforeMount() {
      this.page.isLoading = true;
      if (await this.$service.v2.api.tdg_Users.amICompany()) {
        this.page.initialize();
      } else if (await this.$service.v2.api.tdg_Users.amIOrganisation()) {
        this.$router.push('/tourdegwaerb/organisation/dashboard');
      } else {
        this.$router.push('/TourDeGwaerb/IL/');
      }
    },
    mounted() {
    },
    methods: {
    },
  });
</script>
